import React from 'react';
import {render} from 'react-dom';
import { Router, Route, IndexRoute, Link, hashHistory } from 'react-router';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import injectTapEventPlugin from 'react-tap-event-plugin';

// Views
import Login from './views/login.jsx';
import Home from './views/dashboard.jsx';
import CreateQuizPage from './views/create-quiz.jsx';
import QuizListPage from './views/quiz-list.jsx';
import QuizContainer from './views/quiz-container.jsx';
import QuestionPage from './views/question-page.jsx';
import ScoreSheet from './views/score.jsx';

// Stylesheet
require('./sass/main.scss');

injectTapEventPlugin();

const muiTheme = getMuiTheme({
	palette: {
		primary1Color: '#82CCC8',
		primary2Color: '#00ACC1',
		accent1Color: '#427AA1',
		pickerHeaderColor: '#82CCC8',
	},
	textField: {
		errorColor: '#EBA97A'
	},
});

const App = React.createClass({
	componentWillMount: function() {
		if (!localStorage.getItem('token')) {
			hashHistory.push("/login");
		}
	},
	componentDidMount: function() {
		if (localStorage.getItem('activeQuiz')) {
			this._setActiveQuiz(localStorage.getItem('activeQuiz'));
		}
		if (this.props.location.pathname == '/list' || this.props.location.pathname.substr(0,8) == '/quizzes') {
			this.setState({
				selectedIndex: 2
			});
		}
	},
	getInitialState: function() {
		return {
			selectedIndex: 0,
			activeQuiz: -1
		}
	},
	_selectView: function(index) {
		this.setState({
			selectedIndex: index
		});
	},
	_setActiveQuiz: function(quiz) {
		this.setState({
			activeQuiz: quiz
		});
	},
	render: function() {
		return (
			<div className="app">
				{React.cloneElement(
					this.props.children, {
						activeQuiz: this.state.activeQuiz,
						selectedIndex: this.state.selectedIndex,
						selectView: this._selectView,
						setActiveQuiz: this._setActiveQuiz
					}
				)}
			</div>
		)
	}
});

render((
	<MuiThemeProvider muiTheme={muiTheme}>
		<Router history={hashHistory}>
			<Route path="/" component={App}>
				<IndexRoute component={Home} />
				<Route path="/home" component={Home} />
				<Route path="/login" component={Login} />
				<Route path="/create" component={CreateQuizPage} />
				<Route path="/list" component={QuizListPage} />
				<Route path="/quizzes/:id" component={QuizContainer} />
			</Route>
		</Router>
	</MuiThemeProvider>
), document.getElementById('app'));


// WEBPACK FOOTER //
// ./src/index.jsx